import { useMemo } from "react"

import Typography from "~/components/atoms/Typography"
import { CATEGORY_IMAGE_MAP } from "~/components/pages/NewGradJobsPage/_CategoryItems/CategoryImageMap"
import { CuratedNewGradJobDetail } from "~/entities/CuratedNewGradJob"
import { NewGradJobDetail } from "~/entities/NewGradJob"
import { Schedule } from "../_Rich/_Schedule"

import * as styled from "./styled"

interface Props {
  job: NewGradJobDetail | CuratedNewGradJobDetail
}

const Job = ({ job }: Props) => {
  const schedules = useMemo((): NewGradJobDetail["work_schedules"] | undefined => {
    if (!("work_schedules" in job) || job.work_schedules.length === 0) {
      return
    }
    return job.work_schedules
  }, [job])

  return (
    <styled.EachTabContainer>
      <div className="content-wrapper">
        <div className="occupation-container">
          <div className="occupation-icon">{CATEGORY_IMAGE_MAP[job.major_occupation.name_id]}</div>
          <Typography type="Heading" className="occupation-description">
            {job.company.name}の<br className="occupation-description-br" />“{job.minor_occupation.name}”として働く
          </Typography>
        </div>
        <div className="each-section">
          <Typography type="Heading" className="each-section-heading">
            シゴトについて
          </Typography>
          {job.mission && (
            <div className="section-content">
              <Typography type="SubHeading" className="each-section-sub-heading">
                ミッション
              </Typography>
              <p className="section-detail-content">{job.mission}</p>
            </div>
          )}
          {"services" in job && job.services && (
            <div className="section-content">
              <Typography type="SubHeading" className="each-section-sub-heading">
                携わる事業
              </Typography>
              <p className="section-detail-content">{job.services}</p>
            </div>
          )}
          {job.job_description && (
            <div className="section-content">
              <Typography type="SubHeading" className="each-section-sub-heading">
                具体的な業務
              </Typography>
              <p className="section-detail-content">{job.job_description}</p>
            </div>
          )}
        </div>

        {/* TODO: 配属部署について>部署名,部署の特徴を実装する */}

        {schedules && (
          <div className="each-section">
            <Typography type="Heading" className="each-section-heading">
              {job.minor_occupation.name}の一日のスケジュール
            </Typography>
            <Schedule schedules={schedules} />
          </div>
        )}
      </div>
    </styled.EachTabContainer>
  )
}

export default Job
